'use client';

import { LogError } from '@hc-frontend/features-logger';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <LogError error={error} reset={reset} />;
}
